import React, { useEffect, useState } from 'react';
import { fetchBillingDocs } from '../../../actions/finances';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import PageTitle from '../../common/PageTitle';
import MainBlock from './MainBlock';
import SpinnerBlock from '../../common/SpinnerBlock';
import { useHistory } from 'react-router-dom';

const BillPage = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  const item = useSelector((state) => state.finances.data[0]);
  const history = useHistory();

  useEffect(() => {
    (async function () {
      setLoading(true);
      await dispatch(fetchBillingDocs({ id: props.match.params.id, size: 1 }));
      setLoading(false);
    })();
  }, []);

  return (
    <>
      {!loading && item && (
        <>
          <PageTitle
            customBackLink={history.location.state?.customBackLink || '/finances'}
            title={item.title}
            subtitle={item.description}
            extraStr={`от ${moment(item.date).format('DD.MM.YYYY')}`}
          />
          <MainBlock item={item} />
        </>
      )}
      {loading ? (
        <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
          <SpinnerBlock show={loading} />
        </div>
      ) : null}
    </>
  );
};

export default BillPage;
